import React from 'react';
import { ScrollView, RefreshControl } from 'react-native';
import RoutineCalenderCard from '../../components/Routines/RoutineDetails/RoutineCalenderCard';
import RoutineSummaryWidgetCard from '../../components/Routines/RoutineDetails/RoutineSummaryWidgetCard';
import RoutineActivity from './RoutineActivity';
import RoutineList from './RoutineList';
import UploadButtonWeb from '../../components/productRatings/UploadButtonWeb';
import withRoutineDetails from './withRoutineDetails';
import { SCREEN_CONSTANTS } from '../../config/ScreenConstants';
import { getScreenWidth } from '../../utils/LayoutUtility';
import RoutineScreenPlaceHolder from './RoutineScreenPlaceHolder';
import { isWeb } from '../../utils/BooleanUtility';
import { RoutineActivityShimmer } from './RoutineScreenPlaceHolder';

const DuringRoutineDetails = ({
  isLoading,
  routineDaysData,
  selectedDay,
  selectedDayActivitiesData,
  itemData,
  onChangeDay,
  setListRef,
  setActivityListRef,
  markRoutineActivityAsDone,
  showActivityToast,
  fileInputRef,
  handleFileChange,
  isRoutineActive,
  selectedDaySummaryCardContent = {},
  isSelectedDayLoading = false,
}) => {
  const renderPageContent = () => {
    if (isLoading) {
      return <RoutineScreenPlaceHolder />;
    }

    const {
      artist = {},
      myRewardPoints = '',
      slug = '',
      commonActivities = [],
      dailyPhotoes = [],
      selectedDayDateTime = '',
    } = itemData || {}; // Added fallback to prevent undefined errors
    
    const tabListWidth = getScreenWidth() * 0.75;
    return (
      <>
        {commonActivities.length > 0 && (
          <RoutineList 
            itemData={commonActivities} 
            myRewardPoints={myRewardPoints} 
            isRoutineActive={isRoutineActive}
          />
        )}
        <RoutineCalenderCard
          numberOfDays={routineDaysData?.length || 0}
          selectedDay={selectedDay}
          onChangeDay={onChangeDay}
          isRoutineActive={isRoutineActive}
          setListRef={setListRef}
          routineDaysData={routineDaysData}
        />
        <RoutineSummaryWidgetCard 
          summaryCardData={selectedDaySummaryCardContent} 
        />
        {isSelectedDayLoading ? (
          <RoutineActivityShimmer />
        ) : (
          selectedDayActivitiesData?.map((item, index) => (
            <React.Fragment key={item?.id || `${selectedDay}-${index}`}>
              <RoutineActivity
                item={item}
                index={index}
                artist={artist}
                selectedDay={selectedDay}
                dailyPhotoes={dailyPhotoes}
                selectedDayActivitiesData={selectedDayActivitiesData}
                slug={slug}
                isRoutineActive={isRoutineActive}
                actionButtonPress={markRoutineActivityAsDone}
                selectedDayDateTime={selectedDayDateTime}
                showActivityToast={showActivityToast}
                tabListWidth={tabListWidth}
              />
              {isWeb() && (
                <UploadButtonWeb 
                  fileInputRef={fileInputRef} 
                  handleFileChange={handleFileChange} 
                />
              )}
            </React.Fragment>
          ))
        )}
      </>
    );
  };

  return (
    <ScrollView
      showsVerticalScrollIndicator={false}
      ref={setActivityListRef}
      refreshControl={<RefreshControl refreshing={isLoading} />}
    >
      {renderPageContent()}
    </ScrollView>
  );
};

export default withRoutineDetails(DuringRoutineDetails, SCREEN_CONSTANTS.DURING_ROUTINE);